import React from 'react';
import PropTypes from 'prop-types';
import {Box} from '@material-ui/core';

const ExercisePage = ({children}) => <Box>{children}</Box>;

ExercisePage.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ExercisePage;
